import type { ReactNode } from "react";
import { AnimatePresence, motion } from "framer-motion";

export function RevealSlot({
  revealed,
  skeletonHeight,
  children,
  testId,
}: {
  revealed: boolean;
  skeletonHeight: number;
  children: ReactNode;
  testId?: string;
}) {
  return (
    <AnimatePresence mode="wait" initial={false}>
      {revealed ? (
        <motion.div
          key="content"
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -8 }}
          transition={{ duration: 0.28, ease: [0.2, 0.8, 0.2, 1] }}
        >
          {children}
        </motion.div>
      ) : (
        <motion.div
          key="skeleton"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          data-testid={testId}
          className="overflow-hidden rounded-2xl border border-border/70 bg-[linear-gradient(90deg,rgba(15,23,42,0.04),rgba(15,23,42,0.08),rgba(15,23,42,0.04))] bg-[length:200%_100%]"
          style={{ height: skeletonHeight }}
        >
          <motion.div
            animate={{ x: ["-100%", "100%"] }}
            transition={{ duration: 1.5, repeat: Infinity, ease: "linear" }}
            className="h-full w-1/2 bg-[linear-gradient(90deg,transparent,rgba(255,255,255,0.75),transparent)]"
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
}
